<template>
  <v-row>
    <v-col cols="12" md="8" offset-md="2">
      <transition name="scroll-y-transition">
        <lean-form
          v-if="record"
          :record="record"
          :db-data="dbData"
          :resolved="resolved"
          :loading="loading"
          :datatype="datatype"
          :existingSlug="slug"
          @saved="reload($event)"
        />
      </transition>
    </v-col>
  </v-row>
</template>
<script>
import LeanForm from '@/components/LeanForm';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'LeanFormView',
  components: { LeanForm },
  computed: {
    ...mapState({
      language: 'selectedLanguage',
      models: 'models',
      workspace: 'workspace',
      isSessionLoaded: 'isSessionLoaded',
      viewReload: 'viewReload',
      awsExports: 'awsExports'
    })
  },
  data: function () {
    return {
      loading: true,
      record: null,
      resolved: null,
      dbData: null
    };
  },
  props: {
    datatype: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.isSessionLoaded) {
      return this.fetch();
    }
  },
  watch: {
    async isSessionLoaded(val) {
      if (val && this.isLoggedIn) {
        this.fetch();
      }
    },
    $route: {
      handler() {
        if (this.isSessionLoaded) {
          this.fetch();
        }
      }
    },
    workspace: {
      handler() {
        if (this.isSessionLoaded) {
          return this.fetch();
        }
      }
    },
    language: {
      handler() {
        if (this.isSessionLoaded) {
          this.fetch();
        }
      }
    },
    viewReload: {
      handler() {
        if (this.isSessionLoaded && this.viewReload) {
          this.setViewReload(false);
          return this.fetch();
        }
      }
    }
  },
  methods: {
    ...mapMutations({ setSnackbar: 'setSnackbar', setViewReload: 'setViewReload' }),
    async reload(slug) {
      // we need to wait for S3 event to hit the database index, 2s seems to be about right...
      this.loading = true;
      setTimeout(() => {
        if (this.isNew) {
          return this.$router.push({ path: `/data/${this.$route.params.datatype}/${slug}` });
        }
        return this.fetch();
      }, 2000);
    },
    async fetch() {
      if (this.isNew) {
        this.loading = true;
        this.record = {};
        this.models[this.datatype].schema.map((field) => {
          this.record[field.name] = null;
        });
        this.loading = false;
      } else {
        try {
          this.loading = true;
          this.record = null;
          const path = `data/${this.datatype}/${this.slug}/${this.language}/index.json`;
          this.record = await this.$store.state.sdk.getDocument(path);
          await this.getDocumentFromDB();
          this.loading = false;
        } catch (e) {
          this.loading = false;
          console.error(e);
          this.setSnackbar({ message: e, error: 'error' });
        }
      }
    },
    async getDocumentFromDB(waitingTime = 1) {
      try {
        await this.$store.state.sdk
          .getDocuments({
            datatype: this.datatype,
            language: this.language,
            slug: this.slug,
            destinationBucket: this.awsExports.Storage.AWSS3.publishedBucket
          })
          .then((resp) => {
            this.dbData = resp.records?.[0];
            this.resolved = this.dbData?.resolved_data || null;
          });
      } catch (error) {
        if (waitingTime < 30) {
          const iteration = waitingTime + 1;
          this.setSnackbar({ message: this.$t('database.retry', { iteration }), error: 'error' });
          await this.getDocumentFromDB(iteration);
        } else {
          this.setSnackbar({ message: this.$t('database.failed'), error: 'error' });
          return undefined;
        }
      }
    }
  }
};
</script>
<style></style>
